<template>
  <div class="security">
    <ScreenPanel :isExpand="isLeft">
      <ScreenBoxClick title="安防概览" menuCode="030201">
        <!-- <OverviewSecurityAlarms /> -->
        <AlertOverview></AlertOverview>
      </ScreenBoxClick>
      <ScreenBox title="告警等级统计">
        <AlarmLevelStatistics />
      </ScreenBox>
    </ScreenPanel>
    <ScreenPanel :isExpand="isRight" position="right">
      <ScreenBoxClick title="告警工单历史统计" menuCode="030203">
        <HistoricalAlarmOrder />
      </ScreenBoxClick>
      <ScreenBox title="告警类型历史统计">
        <HistoricalAlarmType />
      </ScreenBox>
    </ScreenPanel>
  </div>
</template>

<script>
import ScreenPanel from "@ISS/situation/components/ScreenPanel";
import ScreenBox from "@ISS/situation/components/ScreenBox";
// import OverviewSecurityAlarms from "@ISS/situation/components/OverviewSecurityAlarms";
import AlertOverview from "../components/AlertOverview";
import AlarmLevelStatistics from "@ISS/situation/components/AlarmLevelStatistics";
import HistoricalAlarmOrder from "@ISS/situation/components/HistoricalAlarmOrder";
import HistoricalAlarmType from "@ISS/situation/components/HistoricalAlarmType";
import ScreenBoxClick from "../components/ScreenBoxClick";

export default {
  name: "Security",
  components: {
    ScreenBoxClick,
    HistoricalAlarmType,
    HistoricalAlarmOrder,
    AlarmLevelStatistics,
    // OverviewSecurityAlarms,
    AlertOverview,
    ScreenBox,
    ScreenPanel
  },
  data() {
    return {
      isLeft: false,
      isRight: false
    }
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.isLeft = true;
    this.isRight = true;
    this.$map.showMap2D();
  }
}
</script>

<style lang="scss" scoped>
.security {
  width: 100%;
  height: 100%;
}
</style>
